import React, {useState} from "react";
import {CreateConstModal} from "../CreateConstant";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const ConstsBlock = ({project, onUpdateProject, getUserProjects}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedConstant, setSelectedConstant] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateConstants = async (data) => {
        await onUpdateProject({...data});
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.constants = newProject?.constants?.filter((item) => item.id !== id);
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = Object?.entries(project?.constants || {})
        ?.map(([key, value]) => ({key, value}))
        ?.filter((item) => item.key?.toLowerCase()?.includes(search?.toLowerCase())) || [];

    return (
        <>
            <CreateConstModal
                open={openModal}
                project={project}
                selectedConstant={selectedConstant}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedConstant(null);
                }}
                handleSubmit={onUpdateConstants}
                onRemove={onRemove}
            />
            <ListBlock
                title="Constants"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(constant) => (
                    <SideItemRow
                        key={constant?.key}
                        label={`${constant?.key} - ${constant?.value}`}
                        tooltip={`${constant?.key} - ${constant?.value}`}
                        onClick={() => {
                            setSelectedConstant(constant.key);
                            setOpenModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
